import { AxiosResponse } from 'axios';
import { useMutation } from 'react-query';

import { BASCULER_VERS_ASSURANCE_END_POINT } from '../../apiEndPoints';
import {
    axiosInstance,
    reactQueryOptions,
    IMutationResult,
    getDynamicHeaders
} from '../../../../api';

export enum ActionsAssurance {
    PROTECTION = 'protection',
    PROFIL = 'profil',
    PREASSURABILITE = 'preassurabilite'
}

const basculerVersAssurance = async (
    idDemande
): Promise<AxiosResponse<any>> => {
    const endPoint = BASCULER_VERS_ASSURANCE_END_POINT.replace(
        /{idDemande}/g,
        String(idDemande)
    );

    const { data } = await axiosInstance.get(
        endPoint,
        await getDynamicHeaders()
    );

    return data;
};

export const useAssuranceApi = (): IMutationResult => {
    return useMutation(basculerVersAssurance, {
        ...reactQueryOptions()
    });
};
